module.exports = __webpack_public_path__ + "static/media/login-back-user-web.79169c9c.jpg";